import { useEffect } from 'react';

import { getSignInProcessState } from 'handlers/curo-handlers/selectors';
import { getCurrentAccount } from 'thunks';
import TokenUtils from 'utils/TokenUtils';

import { useAppSelector } from './reduxHooks';
import useDispatchWithUnwrap from './useDispatchWithUnwrap';
import { useLoadingState } from './useLoadingState';



export enum SessionStatus {
  Verified = 'verified',
  Unverified = 'unverified',
  Loading = 'loading',
}

export const useGetSessionStatus = (): SessionStatus => {
  const [isCheckSessionLoading, setIsCheckSessionLoading] = useLoadingState();
  const { accountData } = useAppSelector(getSignInProcessState);
  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const checkSession = async () => {
    if (accountData) {
      setIsCheckSessionLoading('success');
      return;
    }

    const accessToken = TokenUtils.getAccessToken();
    const refreshToken = TokenUtils.getRefreshToken();

    if (!accessToken && !refreshToken) {
      setIsCheckSessionLoading('error');
      return;
    }

    if (!accountData) {
      try {
        setIsCheckSessionLoading('loading');

        await dispatchWithUnwrap(getCurrentAccount());

        setIsCheckSessionLoading('success');
      } catch (error) {
        setIsCheckSessionLoading('error');
      }
    }
  };

  useEffect(() => {
    checkSession();
  }, []);

  const getSessionStatus = () => {
    switch (isCheckSessionLoading) {
      case 'loading':
      case 'idle':
        return SessionStatus.Loading;
      case 'success':
        return accountData ? SessionStatus.Verified : SessionStatus.Unverified;
      case 'error':
        return SessionStatus.Unverified;
    }
  };

  return getSessionStatus();
};
